export var API = {
    EMAIL_FEEDBACK: 'chat/v1/feedback_ai/',
    CHATBOT_PROMPTS: 'person/v1/chatbot_prompts/',
    CHATBOT_HISTORY: 'chat/v1/chat_history/',
    CLEAR_CHAT_HISTORY: 'chat/v1/clear_chat_history/',
    EDIT_CHAT: 'chat/v1/edit_generated_response/',
    GET_CONVERSATIONS: 'chat/v1/get_channels/',
    EDIT_CONVERSATION: 'chat/v1/edit_channel/',
    PROMPTS: 'chat/v1/prompts/',
    PROMPT_CATEGORIES: 'chat/v1/prompt_categories/',
    DELETE_CONVERSATION: 'chat/v1/delete_channel/',
    CHATBOT: 'chat/v1/conversations/',
    CHAT_FEEDBACK: 'chat/v1/feedback_ai/',
    PERSON_SETUP: 'chat/v1/person_setup/',
    COMPANY_SETUP: 'chat/v1/company_setup/',
    GROUP_SETUP: 'chat/v1/group_setup/',
    RECENT_TAGS: 'chat/v1/recent_tags/',
    RECENT_TAGS_ENTITIES: 'chat/v1/recent_tags_entities/',
    FAVORITE_PROMPTS: 'chat/v1/prompts/favorites/',
    MARK_FAVORITE: 'chat/v1/prompts/mark_favourite/',
    GILROY_DATA: 'chat/v1/data_overview/',
    ADD_REMOVE_PROMPT: 'chat/v1/categories/manage_prompt/',
    EDIT_CATEGORY: 'chat/v1/categories/edit/',
    DELETE_CATEGORY: 'chat/v1/categories/delete/',
    FLURRY_EVENTS_API: 'digest/v1/flurry_events_insertion/',
    USER_PROFILE: 'auth/v1/profile_login/',
    GET_PERSON_PROFILE_DATA: 'person/v1/card/',
    GET_PERSON_EXTENDED_SEARCH: 'search/v1/person_extended_search/',
    GLOBAL_SEARCH_RESULTS: 'search/v1/search_content/',
    REORDER_PROMPTS: 'chat/v1/prompts/reorder/',
    EDIT_PROMPT: 'chat/v1/prompts/edit/',
    SCENERIO_BUILDER_EXPORT: 'chat/v1/scenario_builder/export/',
    GET_ORG_EXECUTIVES: '/buyer_groups/v1/list_org_people/',
    REORDER_CATEGORIES: 'chat/v1/categories/reorder/',
    DOWNLOAD_DOCUMENT: 'chat/v1/hub_download/',
};
export var SectionTypes = {
    Executives: 'Executives',
    Companies: 'Companies',
    BuyerGroups: 'Buyer Groups',
    News: 'News',
    Industries: 'Industries',
    Documents: 'Documents',
};
//routes
export var DOCUMENTS_UPLOAD_ROUTE = '/documents?isUpload=true';
export var FEED_GILROY_ROUTE = '/feed/gilroy';
export var RESTRICT_ROUTE = '/restrict';
export var COMPANY_OVERVIEW_ROUTE = '/company/overview?companyId=';
export var PERSONALITY_INSIGHTS_ROUTE = '/person/personalityinsights?personId=';
export var PEOPLE_ROUTE = '/people';
export var GROUP_DETAIL_ROUTE = '/groupdetails/members/?groupId=';
//SAP consts
export var SMART_REDIRECTION_TEXT = 'Account Plan';
//gilroy consts
export var TAG_CHARACTER = '@';
export var TAG_LIMIT = 5;
export var TAG_LIMIT_MESSAGE = 'Only 5 unique tags are allowed. Please remove an existing tag to add a new one.';
export var DEFAULT_SCENARIO_GILROY_IAMGE = 'https://media.xiqonline.com/salesApp/xiQgptGlobal/scenario-builder-v3.png';
export var DEFAULT_GILROY_IMAGE = 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/salesApp/xiQgptGlobal/gilRoyConversionalV2.png';
export var DEFAULT_GROUP_GILROY_IMAGE = 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/salesApp/xiQgptGlobal/bot-group.png';
export var DEFAULT_GROUP_GILROY_WITHOUT_BORDER_IMAGE = 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/salesApp/xiQgptGlobal/document-group-without-border-icon.png';
export var REVERT_ICON = 'https://s3.us-west-2.amazonaws.com/media.xiqonline.com/salesApp/xiQgptGlobal/gptIconRevert.png';
export var DEFAULT_DOCUMENT_GILROY_IAMGE = 'https://media.xiqonline.com/salesApp/xiQgptGlobal/document-taging-icon-c.png';
export var DISCLAIMER_MESSAGE_M1 = "This content was generated by Gilroy, xiQ's AI-powered assistant using generative AI. While efforts are made to ensure accuracy,\n\nplease independently verify any information before relying on it for decision-making purposes.";
export var PLACEHOLDER_CONTENT_EDITABLE = 'to start tagging people, companies and buyer groups';
export var DELETE_PROMPT_CATEGORY = 'Deleting the scenarios <span class="fw-MBold">“Sales Enablement”</span> will permanently remove all prompts associated with it. This action cannot be undone.';
export var TOOLTIP_FAVORITE_PROMPT = 'With My Favorites, you can easily save and organize your most essential prompts in a personalized list. Quickly access and revisit your top picks anytime, ensuring your go-to prompts are always at your fingertips.';
export var TOOLTIP_CUSTOM_CATEGORY = 'Create scenarios and organize your prompts within for easy access and streamlined management, ensuring your prompts are always well-organized and readily available.';
//certification consts
export var CERTIFICATION_COMP_POPUPS = 'showCertificationPopups';
export var CERTIFICATION_START_POPUP = 'isShowCertification';
export var ChatbotCertificationTypes = ['open_company_profile', 'company_profile_execute_prompt_2', 'company_profile_execute_prompt_3', 'company_profile_execute_prompt_4', 'open_buyer_group', 'buyer_group_execute_prompt_2', 'buyer_group_execute_prompt_3', 'open_person_profile', 'person_profile_execute_prompt_2'];
//translation consts
export var translateSkipAreas = 'skiptranslate';
//gilroy tags
export var PERSON_TAG = '<span class="prompt-input-style personAppend" contenteditable="false">@Person name</span>';
export var COMPANY_TAG = '<span class="prompt-input-style companyAppend" contenteditable="false">@Company name</span>';
export var GROUP_TAG = '<span class="prompt-input-style groupAppend" contenteditable="false">@Buyergroup</span>';
export var DOCUMENT_TAG = '<span class="prompt-input-style documentAppend" contenteditable="false">@Document name</span>';
export var DOCUMENT_TAG_SMALL = '<span class="prompt-input-style documentAppend" contenteditable="false">@document name</span>';
export var TEXT_TAG = '<span class="prompt-input-style textAppend">[Custom Text]</span>';
export var PERSON_INFO = {
    affinityDescription: 'Sundar succeeds best in a relaxed, upbeat setting and is eager to investigate new concepts or ventures.',
    affinityPoints: ['steady', 'independent', 'invaluable', 'highly skilled'],
    archeType: {
        name: 'Persuader', color: '#FA8C16', image: 'https://media.xiq.io/personality_disc_images_v3/Id.png', personality: 'Id',
    },
    companyId: 8115,
    companyLogo: 'https://s3-us-west-2.amazonaws.com/xiqapp-static/company-cropped-logos/Company8115/8115.jpg',
    companyName: 'Alphabet Inc.',
    companyPersonality: [
        {
            color: '#ffb236', percentage: 50, start: '0%', end: '50%',
        },
        {
            color: '#51b4e0', percentage: 25, start: '50%', end: '75%',
        },
        {
            color: '#ed5944', percentage: 25, start: '75%', end: '100%',
        },
    ],
    feedid: 0,
    confidence: '75',
    executiveType: 'Executive',
    headline: '',
    isAdmin: false,
    location: 'Los Altos, California',
    notification: 'Profile is ready to view.',
    personAdded: true,
    personDesignation: 'CEO, Google and Alphabet',
    personId: 7531,
    personImage: 'https://s3-us-west-2.amazonaws.com/xiqapp-static/Executives/7531.jpg',
    personName: 'Sundar Pichai',
    personRefresh: 0,
    personSearch: 0,
    personType: 'EXECUTIVE',
    personalityTypes: [
        {
            cardColor: '#d48806',
            color: '#FA8C16',
            description: 'Influencing',
            image: 'https://media.xiq.io/personality_type_images/id.png',
            key: 'Id',
            value: 'Id',
        },
    ],
    profileStatus: 1,
    email: '',
    phone: '',
    companySubscribers: 0,
    companyPulse: [],
    isSelected: false,
};
export var COMPANY_INFO = {
    accountPlanAllowed: 1,
    companyDomain: "apple.com",
    companyId: 238,
    companyLogo: "https://s3-us-west-2.amazonaws.com/xiqapp-static/company-logos/Company238/238.jpg",
    companyMainWebsite: "apple.com",
    companyName: "Apple Inc.",
    companyNotes: 1,
    companyPersonality: [
        { personality: "Driver", color: "#ffb236", percentage: 44, start: "0%", end: "44%" },
        { personality: "Driver", color: "#4fd39a", percentage: 22, start: "44%", end: "66%" },
        { personality: "Driver", color: "#51b4e0", percentage: 11, start: "66%", end: "77%" },
        { personality: "Driver", color: "#ed5944", percentage: 22, start: "77%", end: "99%" },
    ],
    companyPulse: [
        { name: "Awards", color: "#93A4BA", count: 4, percentage: "3", start: "0%", end: "3%" },
        { name: "Finance", color: "#4DC929", count: 3, percentage: "2", start: "3%", end: "5%" },
        { name: "CxO News", color: "#6C35C0", count: 2, percentage: "1", start: "5%", end: "6%" },
        { name: "Legal", color: "#006FF1", count: 1, percentage: "1", start: "6%", end: "7%" },
        { name: "M&A", color: "#00C7C3", count: 1, percentage: "1", start: "7%", end: "8%" },
        { name: "Products", color: "#F59223", count: 42, percentage: "29", start: "8%", end: "37%" },
        { name: "Partnerships", color: "#F68CAD", count: 6, percentage: "4", start: "37%", end: "41%" },
        { name: "Restructuring", color: "#B846CA", count: 1, percentage: "1", start: "41%", end: "42%" },
        { name: "Regulation", color: "#1A3A96", count: 4, percentage: "3", start: "42%", end: "45%" },
        { name: "Strategy", color: "#F4C600", count: 5, percentage: "3", start: "45%", end: "48%" },
        { name: "Technology", color: "#B83E78", count: 40, percentage: "28", start: "48%", end: "76%" },
        { name: "CxO Moves", color: "#D24556", count: 2, percentage: "1", start: "76%", end: "77%" },
        { name: "HR", color: "#A64E00", count: 2, percentage: "1", start: "77%", end: "78%" },
        { name: "Events", color: "#F1681E", count: 16, percentage: "11", start: "78%", end: "89%" },
        { name: "Cyber Security", color: "#235594", count: 3, percentage: "2", start: "89%", end: "91%" },
        { name: "CX", color: "#FFE05D", count: 8, percentage: "6", start: "91%", end: "97%" },
        { name: "AI", color: "#0492C2", count: 4, percentage: "3", start: "97%", end: "100%" },
    ],
    companyRevenue: "$385.6B",
    companySharePrice: "231.78",
    companySubscribed: false,
    companySubscribers: 8643,
    companyTicker: "AAPL",
    companyWebsite: "www.apple.com",
};
